import React from 'react';
import { Alert } from '@mui/material';

export const DEMO_BANNER_TEXT = 'Demo — sample data';

// Binding rule (Stage 0 item 0.2): no visibility prop — callers own the ai_assistant gate.
export default function DemoBanner({ testId = 'ai-demo-banner' }) {
  return (
    <Alert severity="info" data-testid={testId} role="note" className="ai-demo-banner" sx={{ mb: 1 }}>
      {DEMO_BANNER_TEXT}
    </Alert>
  );
}
